import InputField from 'Components/InputField';

const PasswordField = (props) => <InputField {...props} type="password" />;

export default PasswordField;
